import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

import { api, requete } from "../../shared/api/client";
import type { ActionSurAlerte, Alerte } from "../../shared/api/types";

export function useAlertes(statut: string) {
  return useQuery({
    queryKey: ["alertes", statut],
    queryFn: () => api.lire<Alerte[]>("/v1/alertes" + requete({ "filter[statut]": statut, pageSize: 50 })),
    // Une alerte ouverte doit apparaître vite : contrairement au reste, la fraîcheur du cache reste
    // courte ici.
    staleTime: 30_000,
  });
}

export function useCloturerAlerte() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ alertId, corps }: { alertId: string; corps: ActionSurAlerte }) =>
      api.modifier<Alerte>(`/v1/alertes/${encodeURIComponent(alertId)}`, corps),
    onSuccess: () => {
      void client.invalidateQueries({ queryKey: ["alertes"] });
    },
  });
}
